<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <div class="level">
        <div class="level-left">
          <h1 class="title is-5">{{ $t('routes.documentTypes') }}</h1>
        </div>
        <div class="level-right">
          <div class="field is-grouped controls">
            <div class="control">
              <button @click="goTo('createDocumentType')"
                      class="button is-success">
                {{ $t('interface.createNewObject') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="level table-actions">
        <div class="level-left">
          <form @submit.prevent="onSearch">
            <div class="field is-grouped controls">
              <div class="control">
                <b-input v-model="q" :placeholder="$t('interface.search')"></b-input>
              </div>
              <div class="control mr-10">
                <button type="submit" class="button is-primary">
                  <b-icon icon="magnify" size="is-small"></b-icon>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <b-table class="mt-10"
               :data="list"
               :loading="loading"

               paginated
               backend-pagination
               :total="total"
               :per-page="perPage"
               @page-change="onPageChange"

               backend-sorting
               default-sort-direction="desc"
               :default-sort="[sortField, sortOrder]"
               @sort="onSort">
        <template slot-scope="props">
          <b-table-column :label="`${$t('admin.name')} (ru)`" field="name_ru" sortable>
            {{ props.row.name_ru }}
          </b-table-column>
          <b-table-column :label="`${$t('admin.name')} (uz)`" field="name_uz" sortable>
            {{ props.row.name_uz }}
          </b-table-column>
          <b-table-column :label="$t('admin.abbr')" field="abbr" sortable>
            {{ props.row.abbr }}
          </b-table-column>
          <b-table-column :label="$t('admin.registerBook')" field="register_book" sortable>
            {{ props.row.register_book__name }}
          </b-table-column>
          <b-table-column :label="$t('admin.category')" field="category" sortable>
            {{ $t(`admin.docTypeCategory.${props.row.category}`) }}
          </b-table-column>
          <b-table-column :label="$t('admin.weight')" field="weight" sortable>
            {{ props.row.weight }}
          </b-table-column>
          <b-table-column width="180">
            <div class="has-text-right">
              <button class="button is-small is-primary mr-5" @click="edit(props.row.id)">
                <b-icon icon="pencil" size="is-small"></b-icon>
              </button>
              <button class="button is-small is-danger" @click="remove(props.row.id)">
                <b-icon icon="delete" size="is-small"></b-icon>
              </button>
            </div>
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content is-fluid has-text-grey has-text-centered">
              <p>Ничего не найдено, попробуйте <a class="is-dashed" @click.prevent="resetFilters">сбросить фильтры и
                поиск</a>.</p>
            </div>
          </section>
        </template>
      </b-table>
    </div>
  </DashboardLayout>
</template>

<script>
  import {mapGetters, mapState} from 'vuex'
  import {priorityColors, stateColors} from '@/colorTypes'
  import DashboardLayout from '@/components/DashboardLayout'
  import GovernmentAgencySelect from '@/components/GovernmentAgencySelect'
  import {deleteObjectKeysByValue} from '@/utils'

  export default {
    components: {
      DashboardLayout,
      GovernmentAgencySelect
    },
    data() {
      return {
        loading: false,
        total: 0,
        page: 1,
        perPage: 15,
        q: '',
        sortField: '',
        sortOrder: 'desc',
        priorityColors,
        stateColors
      }
    },
    methods: {
      loadData() {
        this.loading = true
        this.checkedRows = []
        let params = {
          page: this.page,
          page_size: this.perPage,
          q: this.q,
          ordering: `${this.sortOrder === 'desc' ? '-' : ''}${this.sortField}`,
        }
        this.$store.dispatch('Moderator/getList', {actionType: 'document_types', params}).then((response) => {
          this.loading = false
          this.total = response.count
        })
      },
      onSort(field, order) {
        this.sortField = field
        this.sortOrder = order
        this.loadData()
      },
      onPageChange(page) {
        this.page = page
        this.loadData()
      },
      onSearch() {
        this.loadData()
      },
      goTo(route) {
        this.$router.push({name: route})
      },
      edit(id) {
        this.$router.push({name: 'editDocumentType', params: {id}})
      },
      remove(id) {
        this.$dialog.confirm({
          title: `Подтвердите действие`,
          message: `Вы уверены, что хотите удалить запись?`,
          confirmText: this.$t('interface.remove'),
          cancelText: this.$t('interface.cancel'),
          type: 'is-danger',
          hasIcon: true,
          onConfirm: () =>
            this.$store.dispatch('Moderator/remove', {actionType: 'document_types', id}).then(() => this.loadData())
        })
      },
    },
    computed: {
      ...mapState('Moderator', ['list']),
      checkedRowsCount() {
        return this.checkedRows.length
      },
      breadcrumbs() {
        return [
          {name: 'documentTypes'}
        ]
      }
    },
    mounted() {
      this.loadData()
      this.$store.dispatch('IssueTracker/getRelations')
    }
  }
</script>
